import { lazy } from "react";
import SecurityConnexion from "./SecurityConnexion";

const Informations = lazy(() => import("./Informations"));
const Preferences = lazy(() => import("./Preferences"));
const Paiements = lazy(() => import("./Paiements"));
const Infocompany = lazy(() => import("./Infocompany"));
const Theme=lazy(()=>import ("./Theme"));
const Devise = lazy(() => import("./Devise"));
const TwoFactorSetup = lazy(() => import("./TwoFactorSetup"));
const SettingsRoutes = [
  {
    path: "/settings/information",
    element: <Informations />,
  },
  {
    path: "/settings/preferences",
    element: <Preferences />,
  },
  {
    path: "/settings/paiements",
    element: <Paiements />,
  },
  {
    path: "/settings/Entreprise",
    element: <Infocompany />,
  },
  {
    path: "/settings/theme",
    element: <Theme />,
  },
  {
    path: "/settings/devise",
    element: <Devise />,
  },  
  {
    path: "/settings/two-factor-setup",
    element: <TwoFactorSetup />,
  },
  {
    path:"/settings/LoginSecurity",
    element:<SecurityConnexion/>
  }
  
 
];

export default SettingsRoutes;
